export const MODULE_NAME = 'filter';

export const DEFAULT_VALUE_RENTAL_PLAN = 12;
export const DEFAULT_VALUE_SORT = 'rank';
export const DEFAULT_VALUE_IN_STOCK = false;
export const DEFAULT_VALUE_MIXABLE = false;

export const SPEC_FILTER_RANGE_QS_KEY = 'range_filters';
export const SPEC_FILTER_MATCH_QS_KEY = 'match_filters';
